// @flow
import React from 'react';
import { Flex } from 'grid-styled';
import { Scrollbars } from 'react-custom-scrollbars';

import LegendItem from './LegendItem';

type Props = {
  height: number,
  legendData: any[],
  hoveredId: string,
  selectedId: string,
  setSelected(id: string): void,
  setHovered(id: string | null, date: string | null, prevId?: string): void,
};

const FlexChartLegend = ({
  height,
  legendData,
  hoveredId,
  selectedId,
  setSelected,
  setHovered,
}: Props) => (
  <Scrollbars style={{ height }}>
    <Flex flexWrap="wrap" width="auto" style={{ overflowY: 'auto' }}>
      {legendData.map(({ name, color, id }) => (
        <LegendItem
          key={id}
          name={name}
          color={color}
          isSelected={selectedId === id}
          isHovered={hoveredId === id}
          onClick={() => setSelected(id)}
          onMouseOver={() => setHovered(id, null)}
          onMouseOut={() => setHovered(null, null, id)}
        />
      ))}
    </Flex>
  </Scrollbars>
);

export default FlexChartLegend;



// WEBPACK FOOTER //
// ./src/components/FlexChartLegend/FlexChartLegend.jsx